///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { keyCodes } from "./types";
import { getGridId } from "./tableSelection";

export const getElement = (isLaneMatch, row, col) =>
  document.querySelector(`#${getGridId(isLaneMatch)} [id='${row}_${col}']`);

const navigate = (
  event,
  rowIndex,
  colIndex,
  columnCount,
  isLaneMatch,
  rowCount
) => {
  const {
    keyCode,
    target: { selectionEnd, selectionStart, value }
  } = event;
  let newColumn = colIndex;
  let newRow = rowIndex;
  let nextElement;

  switch (keyCode) {
    case keyCodes.f2:
      if (event.target.type === "text") {
        event.target.selectionStart = event.target.selectionEnd = value.length;
      }
      break;
    case keyCodes.down:
      nextElement = getElement(isLaneMatch, ++newRow, colIndex);
      if ((!nextElement || nextElement.disabled) && newRow < rowCount) {
        return navigate(
          event,
          newRow,
          colIndex,
          columnCount,
          isLaneMatch,
          rowCount
        );
      }
      break;
    case keyCodes.enter:
      if (event.shiftKey) {
        nextElement = getElement(isLaneMatch, --newRow, colIndex);
      } else {
        nextElement = getElement(isLaneMatch, ++newRow, colIndex);
      }
      break;
    case keyCodes.up:
      nextElement = getElement(isLaneMatch, --newRow, colIndex);
      if ((!nextElement || nextElement.disabled) && newRow >= 0) {
        return navigate(
          event,
          newRow,
          colIndex,
          columnCount,
          isLaneMatch,
          rowCount
        );
      }
      break;
    case keyCodes.left:
      for (
        newColumn--;
        newColumn >= 0 &&
        !event.shiftKey &&
        (selectionStart === null ||
          selectionStart === 0 ||
          selectionStart === undefined);
        newColumn--
      ) {
        nextElement = getElement(isLaneMatch, rowIndex, newColumn);
        if (nextElement && !nextElement.disabled) {
          break;
        }
      }
      break;
    case keyCodes.right:
      for (
        newColumn++;
        newColumn < columnCount &&
        !event.shiftKey &&
        (selectionStart === null ||
          selectionStart === value.length ||
          (selectionStart === 0 && selectionEnd === value.length));
        newColumn++
      ) {
        nextElement = getElement(isLaneMatch, rowIndex, newColumn);
        if (nextElement && !nextElement.disabled) {
          break;
        }
      }
      break;
    default:
      return;
  }

  if (nextElement && (newColumn !== colIndex || newRow !== rowIndex)) {
    nextElement.focus();
    event.preventDefault();
  }
};

export default navigate;
